import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: '',
        component: () => import('../views/home/home.vue')
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/home.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/register/register.vue')
    },
    {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import("../views/login/resetPassword.vue")
    },
    {
        path: '/iws',
        name: 'iws',
        component: () => import("../views/pages/iws.vue")
    },
    {
        path: '/editScene',
        name: 'editScene',
        component: () => import('../../../components/sceneManage/editScene/editScene.vue')
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router